import React, { FC } from 'react'

import stripMarkdown from 'components/shared/utils/stripMarkdown'

export interface ArticleData {
  title: string
  short_description: string
}

export interface FAQPageJsonLdProps {
  keyOverride?: string
  articleDataArr: ArticleData[]
}

export const FAQPageJsonLd: FC<FAQPageJsonLdProps> = ({
  keyOverride,
  articleDataArr,
}) => {
  const jsonld = `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ${articleDataArr.map(
        (articleData: any) => `{
        "@type": "Question",
        "name": "${articleData.attributes.title}" ,
        "acceptedAnswer": {
        "@type": "Answer",
        "text": ${stripMarkdown(articleData.attributes.short_description)}
        }
    }`
      )}
    ]
  }`

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonld }}
      key={`jsonld-article${keyOverride ? `-${keyOverride}` : ''}`}
    />
  )
}
